<p-messages key="infoDoc"></p-messages>
<p-toast key="toast" [style]="{marginTop: '80px'}"></p-toast>
<p-toast position="center" key="confDoc" (onClose)="onReject()" [baseZIndex]="5000">
    <ng-template let-message pTemplate="message">
        <div style="text-align: center">
            <i class="pi pi-exclamation-triangle" style="font-size: 3em"></i>
            <h3>{{message.summary}}</h3>
            <p>{{message.detail}}</p>
        </div>
        <div class="ui-g ui-fluid">
            <div class="ui-g-6">
                <button type="button" pButton (click)="onConfirm()" label="Yes" class="ui-button-success"></button>
            </div>
            <div class="ui-g-6">
                <button type="button" pButton (click)="onReject()" label="No" class="ui-button-secondary"></button>
            </div>
        </div>
    </ng-template>
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div *ngIf="!displayState.addDocumentDiv">
    <div class="container container-data-entry">
        <div *ngIf = "allowUpload">
        <button class="btn btn-link btn-sm" (click)="addDoc()">Add a document</button>
        </div>
        <table class="table" style="width: 80%;">
            <tr style="font-size: smaller">
                <th>Document Type</th>
                <th>Desc (if Other)</th>
                <th>FileName</th>
                <th>Create Date</th>
                <th></th>
            </tr>

            <tr *ngFor="let doc of myDocs">
                <td>{{doc.description}}</td>
                <td>{{doc.descriptionOther}}</td>
                <td>{{doc.documentName}}</td>
                <td>{{ doc.creationDate | date:'shortDate'}}</td>
                <td><button class="btn btn-sm btn-link" (click)="viewDoc(doc)">View</button></td>
                <div *ngIf = "allowDelete">
                    <td> <button class="btn btn-sm btn-link" (click)="deleteDoc(doc)">Delete</button> </td>
                </div>
            </tr>
        </table>
    </div>
</div>
<div class="container container-data-entry" *ngIf="displayState.addDocumentDiv">
    <hr />
    <!-- Document Description -->
    <div class="form-row">
        <label for="inputDocDescription" class="col-sm-2 col-form-label prd-label">Document Description</label>
        <select class="col-sm-3" id="inputDocDescription" [(ngModel)]="myDocument.description" (change)="dataChange()">
            <option *ngFor = "let docType of documentTypeChoiceList">{{docType.name}}</option>
        </select>
        <div class="col-md-4 col-md-offset-1" *ngIf="myDocument.description == 'Other'">
            <input type="text" class="form-control input-sm" [(ngModel)]="myDocument.descriptionOther" placeholder="Enter Doc Type if Other" />
        </div>
    </div>
</div>


<div class="container container-data-entry" *ngIf="displayState.addDocumentDiv">
    <hr />
    <div class="col-md-8">
        <div class="upload-div">
            <div>
                <p-toast key="upl" [style]="{marginTop: '80px'}"></p-toast>
                <p-toast position="center" key="c" (onClose)="onReject()" [baseZIndex]="5000"></p-toast>
                <p-fileUpload title="Drag/Drop enabled" name="uploadedFiles" id="uploadFiles" mode="advanced" customUpload="true" multiple="multiple" (uploadHandler)="myUploader($event)" (onProgress)="showProgress($event)" (onUpload)="showComplete($event)"
                        (onError)="onError($event)" accept=".pdf,.doc,.docx,.txt,.rtf" maxFileSize="10000000">
                    <ng-template pTemplate="content">
                        <ul *ngIf="uploadedFiles.length">
                            <li *ngFor="let file of uploadedFiles">{{file.name}} - {{file.size}} bytes</li>
                        </ul>
                    </ng-template>
                </p-fileUpload>
            </div>
            <hr />
            <button class="btn btn-link btn-sm control-label-appeals-delete" (click)="cancelAddDoc()" title="Click this link to return to Document list">Cancel add a document</button>
        </div>
    </div>
</div>
